import * as React from "react";
import { useState, useCallback, useEffect, useMemo, useRef } from "react";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import { registerCallbacks, reportError, reportSuccess } from "api/server-availability";
import ServerAvailabilityContext from "./ServerAvailabilityContext";
const ServerAvailabilityProvider = ({ children }) => {
  const [server, setServer] = useState({ up: true });
  const [version, setVersion] = useState(void 0);
  const versionRef = useRef(version);
  useEffect(() => {
    versionRef.current = version;
  }, [version]);
  const ping = useCallback(
    () => window.fetch(qualifyUrl(ApiRoutes.ping().url), {
      method: "GET",
      headers: {
        Accept: "application/json",
        "X-Graylog-No-Session-Extension": "true"
      }
    }).then((resp) => resp.json()).then((response) => {
      if ((response == null ? void 0 : response.version) !== versionRef.current) {
        setVersion(response == null ? void 0 : response.version);
      }
      reportSuccess();
    }).catch((error) => {
      reportError(error);
    }),
    []
  );
  useEffect(() => {
    ping();
  }, []);
  useEffect(() => {
    registerCallbacks(
      (error) => setServer((prev) => prev.up ? { up: false, error } : prev),
      () => setServer((prev) => !prev.up ? { up: true } : prev)
    );
    return () => registerCallbacks(null, null);
  }, []);
  const value = useMemo(() => ({ server, version, ping }), [server, version, ping]);
  return /* @__PURE__ */ React.createElement(ServerAvailabilityContext.Provider, { value }, children);
};
export default ServerAvailabilityProvider;
